export { NotificationDot } from './NotificationDot';
export type { NotificationDotProps } from './NotificationDot';
